<app-select-filter [elements]="elements"
                   [parentFormControlName]="parentFormControlName"
                   [parentFormGroup]="parentFormGroup"
                   noEntriesFoundLabel="Aucune année trouvée"
                   placeHolderLabel="Sélectionner une année"
>
</app-select-filter>
